import { LangSwitch } from '../comp/chooseLang/ChooseLang';
import type { PageContent } from '../comp/chooseLang/ChooseLang';
import ImageParagraph from '../comp/imgParagraph/ImageParagraph';
import './Global.css'

const repoUrl = 'https://github.com/Im-Bee/wolfenstein_like_rendering_in_terminal';

const pageContentPl: PageContent[] = [
    {
        header: 'Na stronie (kliknij aby przejść):',
        type: 'pageNav',
        content: '#o-projekcie, #opis',
        custom: null
    },

    // ---------- O projekcie ----------
    {
        header: '#o-projekcie',
        type: 'full',
        content: 'Projekt powstał, aby poznać renderowanie w stylu raycastingu, z niecodziennym pomysłem: renderer wypisuje obraz bezpośrednio w terminalu.',
        custom: null
    },
    {
        header: '',
        type: 'custom',
        content: '',
        custom: <ImageParagraph
            Header='Ascii Raycaster'
            Paragrahps={<a href={repoUrl} target='_blank' rel='noopener noreferrer'>Kod źródłowy na GitHubie</a>}
            Img='/ray-promo.jpg'
            Type=''
            MaxHeight={500} />
    },
    {
        header: 'alt',
        type: 'spacer',
        content: '',
        custom: null
    },

    // ---------- Opis ----------
    {
        header: '#opis',
        type: 'full',
        content: '',
        custom: null
    },
    {
        header: 'Renderowanie w terminalu',
        type: 'sub',
        content: 'Do narysowania obrazu, renderowanego za pomocą znaków ASCII, projekt używa API systemu operacyjnego.',
        custom: null
    },
    {
        header: 'Sterowanie',
        type: 'sub',
        content: 'W systemie Windows jest też działająca (obecnie zakomentowana) obsługa wejścia, pozwalająca poruszać się i obracać po mapie.',
        custom: null
    },
];

const pageContentEn: PageContent[] = [
    {
        header: 'On this site (click to scroll):',
        type: 'pageNav',
        content: '#about, #description',
        custom: null
    },

    // ---------- About ----------
    {
        header: '#about',
        type: 'full',
        content: 'This project was made to learn about raycast style rendering, with a unique twist: the renderer outputs directly to the terminal.',
        custom: null
    },
    {
        header: '',
        type: 'custom',
        content: '',
        custom: <ImageParagraph
            Header='Ascii Raycaster'
            Paragrahps={<a href={repoUrl} target='_blank' rel='noopener noreferrer'>Source code on GitHub</a>}
            Img='/ray-promo.jpg'
            Type=''
            MaxHeight={500} />
    },
    {
        header: 'alt',
        type: 'spacer',
        content: '',
        custom: null
    },

    // ---------- Description ----------
    {
        header: '#description',
        type: 'full',
        content: '',
        custom: null
    },
    {
        header: 'Rendering in the terminal',
        type: 'sub',
        content: 'The project uses the operating system API to draw the picture, which is rendered with ASCII characters.',
        custom: null
    },
    {
        header: 'Input',
        type: 'sub',
        content: 'On Windows there is also working (but currently commented out) support for input, which allows moving and rotating within the map.',
        custom: null
    },
];

function Raycaster() {
    var m = new Map<string, PageContent[]>();
    m.set('en', pageContentEn);
    m.set('pl', pageContentPl);

    return (
        <>
            <LangSwitch LangMap={m} />
        </>
    );
};

export default Raycaster;
